import type { LineLayerSpecification, VectorSourceSpecification } from 'mapbox-gl';

export const BD_STATES_SOURCE_ID = 'states';
export const BD_STATES_LAYER_NAME = 'states';

export const BD_STATES_LAYER_CONFIG: LineLayerSpecification = {
  id: BD_STATES_LAYER_NAME,
  type: 'line',
  source: BD_STATES_SOURCE_ID,
  'source-layer': 'germany_federal_districts',
  paint: {
    'line-color': '#452a71',
  },
};

export const BD_STATES_SOURCE: VectorSourceSpecification = {
  type: 'vector',
  url: 'mapbox://sseemann.cm1hnm4kq0nbf1nod536hzzw7-2y785',
};

export interface BD_STATES_SOURCE_FEATURE_PROPERTIES {
  name: string;
  stateId: string;
}
